import {getCodeLengthApi} from "../api/data_bind";


export function matchCode(code,big,mid,small) {

    if (big.includes(code.length)) {
        return '大'
    }
    if (mid.includes(code.length)) {
        return '中'
    }
    if (small.includes(code.length)) {
        return '小'
    }

    return '无效'

}